export const VCHASNO_TAX_GROUP_OPTIONS = Array.from({ length: 9 }, (_, i) => ({
  id: i + 1,
  name: `prro.tax_groups.${i + 1}`,
}));

export const VCHASNO_PAYMENT_CODES = [0, 1, 2, 3, 4, 5, 6, 8, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const;

export const FISCAL_STATUSES = [
  'prepared',
  'queued',
  'processing',
  'succeeded',
  'skipped',
  'retry_required',
  'collision',
  'unknown',
  'manual_required',
] as const;
export type FiscalStatus = (typeof FISCAL_STATUSES)[number];
export interface CashRegister {
  id: string;
  name: string;
  fiscal_number: string;
  is_active: boolean;
  is_test: boolean | null;
  has_token: boolean;
}
export interface FiscalMapping {
  payment_type_id: string;
  payment_service_id: string | null;
  payment_code: number;
  requires_card_metadata: boolean;
}
export interface FiscalSettings {
  default_tax_group: number | null;
  payment_mappings: FiscalMapping[];
  can_manage?: boolean;
}
export interface FiscalOperation {
  id: string;
  cash_register_id: string;
  payment_id?: string | null;
  card_id?: string | null;
  task?: number;
  status: FiscalStatus;
  receipt_url: string | null;
  fiscal_receipt_number: string | null;
  error: Record<string, unknown> | null;
  warnings?: unknown[];
  response?: Record<string, unknown> | null;
  request_snapshot?: Record<string, unknown>;
  created_at?: string;
  attempts?: number;
}
export interface FiscalShift {
  id: string;
  cash_register_id: string;
  external_id: string;
  status: string;
  opened_at: string | null;
  closed_at: string | null;
  opening_operation_id: string | null;
  closing_operation_id: string | null;
}
export interface RegisterStatus {
  is_open: boolean | null;
  is_online: boolean | null;
  opened_at: string | null;
  shift_id: string | null;
  cash_balance: number | null;
  result: { status: string; error: unknown };
}
export interface FiscalPage<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}
export interface FiscalHistory {
  items: Record<string, unknown>[];
  page_num: number;
  page_size: number;
  has_next: boolean;
  has_prev: boolean;
}
export interface ReceiptPreview {
  preview_revision: string;
  paid_total?: number;
  remaining?: number;
  settlement_status?: 'new' | 'final' | 'advance_pending' | 'receipt_pending' | 'completed' | 'unlinked' | 'refunded';
  total: number;
  rows: { taxgrp: number; name: string; cnt: number; price: number; cost?: number; disc?: number; code?: string; code1?: string }[];
}
export const canRetryFiscal = (operation: FiscalOperation): boolean => operation.status === 'manual_required';

export interface FiscalReturnPreview {
  source_operation_id: string;
  source_receipt_number: string;
  source_receipt_url: string | null;
  cash_register_id: string;
  advance: boolean;
  remaining: number;
  pending: boolean;
  rows: { index: number; name: string; price: number; quantity: number;
    original_quantity: number; used_quantity: number; total: number }[];
  returns: (FiscalOperation & { amount: number })[];
}
